var HttpHeader;
(function (HttpHeader) {
    HttpHeader["ACCEPT"] = "Accept";
    HttpHeader["AUTHORIZATION"] = "Authorization";
    HttpHeader["CONTENT_TYPE"] = "Content-Type";
})(HttpHeader || (HttpHeader = {}));
var HttpMethod;
(function (HttpMethod) {
    HttpMethod["DELETE"] = "DELETE";
    HttpMethod["GET"] = "GET";
    HttpMethod["POST"] = "POST";
    HttpMethod["PUT"] = "PUT";
})(HttpMethod || (HttpMethod = {}));
var HttpStatus;
(function (HttpStatus) {
    HttpStatus[HttpStatus["OK"] = 200] = "OK";
    HttpStatus[HttpStatus["CREATED"] = 201] = "CREATED";
    HttpStatus[HttpStatus["NO_CONTENT"] = 204] = "NO_CONTENT";
    HttpStatus[HttpStatus["MULTIPLE_CHOICES"] = 300] = "MULTIPLE_CHOICES";
    HttpStatus[HttpStatus["MOVED_PERMANENTLY"] = 301] = "MOVED_PERMANENTLY";
    HttpStatus[HttpStatus["FOUND"] = 302] = "FOUND";
    HttpStatus[HttpStatus["SEE_OTHER"] = 303] = "SEE_OTHER";
    HttpStatus[HttpStatus["TEMPORARY_REDIRECT"] = 307] = "TEMPORARY_REDIRECT";
    HttpStatus[HttpStatus["PERMANENT_REDIRECT"] = 308] = "PERMANENT_REDIRECT";
    HttpStatus[HttpStatus["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    HttpStatus[HttpStatus["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    HttpStatus[HttpStatus["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
})(HttpStatus || (HttpStatus = {}));
var MediaType;
(function (MediaType) {
    MediaType["APPLICATION_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    MediaType["APPLICATION_JSON"] = "application/json";
    MediaType["APPLICATION_OCTET_STREAM"] = "application/octet-stream";
    MediaType["APPLICATION_PDF"] = "application/pdf";
    MediaType["APPLICATION_YAML"] = "application/yaml";
    MediaType["IMAGE_BMP"] = "image/bmp";
    MediaType["IMAGE_GIF"] = "image/gif";
    MediaType["IMAGE_JPEG"] = "image/jpeg";
    MediaType["IMAGE_JPG"] = "image/jpg";
    MediaType["IMAGE_PNG"] = "image/png";
    MediaType["MULTIPART_FORM_DATA"] = "multipart/form-data";
    MediaType["TEXT_CSS"] = "text/css";
    MediaType["TEXT_HTML"] = "text/html";
    MediaType["TEXT_PLAIN"] = "text/plain";
})(MediaType || (MediaType = {}));
const DEFAULT_HTTP_HEADERS = {
    [HttpHeader.ACCEPT]: MediaType.APPLICATION_JSON,
    [HttpHeader.CONTENT_TYPE]: MediaType.APPLICATION_JSON,
};
export { DEFAULT_HTTP_HEADERS, HttpHeader, HttpMethod, HttpStatus, MediaType, };
//# sourceMappingURL=http-service-constants.js.map